<template>
  <page>
    <v-card>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md6>
                          <v-text-field
                            v-model="filters.description"
                            :label="labels.description"
                            :error-messages="errors.collect('description')"
                            data-vv-name="description"
                            :data-vv-as="labels.description"
                            v-validate="'name'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex md6>
                          <cal-picker
                            :label="labels.fromDate"
                            v-model="filters.fromDate"
                            :error-messages="errors.collect('fromDate')"
                            data-vv-name="fromDate"
                            :data-vv-as="labels.fromDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex md6>
                          <cal-picker
                            :label="labels.toDate"
                            v-model="filters.toDate"
                            :error-messages="errors.collect('toDate')"
                            data-vv-name="toDate"
                            :data-vv-as="labels.toDate"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <message :messages="messages"></message>
      </v-flex>
      <v-flex>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            v-bind:options.sync="pagination"
            :server-items-length="totalItems"
            :loading="loading"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :no-data-text="noDataText"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.description }}</td>
                <td class="text-xs-left">{{ row.item.fromDate }}</td>
                <td class="text-xs-left">{{ row.item.toDate }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview(row.item.tranDateType)"
                    query
                    @query="doQuery(row.item.tranDateType)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>
    <v-dialog v-model="transDateRangeReview" width="800px" persistent>
      <v-card>
        <v-toolbar v-if="reviewMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title>Edit Transaction Date Range </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="queryMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-magnify</v-icon>
          <v-toolbar-title>Query Transaction Date Range </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-subheader class="queryLabel">{{ labels.tranDateType }}</v-subheader>
                <div class="queryValue">{{ transDateRangeForm.description }}</div>
              </v-flex>
              <v-flex xs6>
                <cal-picker
                  :readonly="queryMode"
                  :label="labels.fromDate"
                  v-model="transDateRangeForm.fromDate"
                  :error-messages="errors.collect('fromDate')"
                  data-vv-name="fromDate"
                  :data-vv-as="labels.fromDate"
                  v-validate="startDateValidation"
                ></cal-picker>
              </v-flex>
              <v-flex xs6>
                <cal-picker
                  :readonly="queryMode"
                  :label="labels.toDate"
                  v-model="transDateRangeForm.toDate"
                  :error-messages="errors.collect('toDate')"
                  data-vv-name="toDate"
                  :data-vv-as="labels.toDate"
                  v-validate="endDateValidation"
                  :min="transDateRangeForm.fromDate"
                ></cal-picker>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ transDateRangeForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ transDateRangeForm.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ transDateRangeForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ transDateRangeForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" v-if="reviewMode" text @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'
export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Transaction Date Type', value: 'description' },
        { text: 'From Date', value: 'fromDate' },
        { text: 'To Date', value: 'toDate' },
        TableConst.tableActionHeader
      ],
      transDateRangeReview: false,
      labels: {
        tranDateType: 'Transaction Date Type',
        description: 'Description',
        fromDate: 'From Date',
        toDate: 'To Date',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      transDateRangeForm: {
        tranDateType: null,
        description: null,
        fromDate: null,
        toDate: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      filters: {
        description: undefined,
        fromDate: undefined,
        toDate: undefined
      },
      tranDateTypeList: [],
      totalItems: 0,
      loading: false,
      reviewMode: false,
      queryMode: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit(true)
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.tranDateRangeList
      /* -- From search to Filter
      if (apiURI) {
        this.loading = true
        this.$http.get(apiURI).then(result => {
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(tranDateRange => {
              const convertList = {
                tranDateType: tranDateRange.tranDateType,
                description: tranDateRange.description,
                fromDate: this.formatDate(tranDateRange.fromDate),
                toDate: this.formatDate(tranDateRange.toDate)
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
      */
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let cloneFilters = clone(this.filters)
          if (cloneFilters.fromDate) {
            cloneFilters.fromDate = formatDisplayDateTime2(removeTime(cloneFilters.fromDate))
          }
          if (cloneFilters.toDate) {
            cloneFilters.toDate = formatDisplayDateTime2(removeTime(cloneFilters.toDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), cloneFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  tranDateType: datamap.tranDateType,
                  description: datamap.description,
                  fromDate: this.formatDate(datamap.fromDate),
                  toDate: this.formatDate(datamap.toDate)
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async getTranDateTypeList() {
      const apiURI = this.menu.tranDateTypeList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.tranDateTypeList = data.data.tranDateTypeList
        }
      } catch (err) {
        throw err
      }
    },
    async doReview(tranDateType) {
      this.reviewMode = true
      this.queryMode = false
      this.doFetchData(tranDateType)
    },
    async doQuery(tranDateType) {
      this.reviewMode = false
      this.queryMode = true
      this.doFetchData(tranDateType)
    },
    doFetchData(tranDateType) {
      this.resetValidator()
      this.resetMessages()
      if (tranDateType) {
        const apiURI = this.menu.tranDateRange
        if (apiURI) {
          this.$http
            .get(expandURI(apiURI, { tranDateType }))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.transDateRangeForm.tranDateType = data.tranDateType.tranDateType
                this.transDateRangeForm.description = data.tranDateType.description
                this.transDateRangeForm.fromDate = removeTime(data.tranDateType.fromDate)
                this.transDateRangeForm.toDate = removeTime(data.tranDateType.toDate)
                this.transDateRangeForm.createdBy = data.createdBy
                this.transDateRangeForm.createdDate = data.createdDate
                this.transDateRangeForm.modifiedBy = data.modifiedBy
                this.transDateRangeForm.modifiedDate = data.modifiedDate
                this.transDateRangeReview = true
              }
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doUpdate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doUpdate() {
      const apiURI = this.menu.updateTranDateRange
      if (apiURI) {
        this.$http
          .put(apiURI, this.transDateRangeForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit(true)
              this.doClose()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.transDateRangeForm.tranDateType = null
      this.transDateRangeForm.description = null
      this.transDateRangeForm.fromDate = null
      this.transDateRangeForm.toDate = null
      this.transDateRangeReview = false
      // setTimeout(() => {
      //   this.newFund = false
      // }, 200)
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.description = undefined
      this.filters.fromDate = undefined
      this.filters.toDate = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    }
  },
  computed: {
    menu() {
      return this.$store.state.tranDateRangeParam.menu
    },
    startDateValidation() {
      return 'required|accept_start_date:' + this.transDateRangeForm.toDate
    },
    endDateValidation() {
      return 'required|from_to_date:' + this.transDateRangeForm.fromDate
    },
    filteredItems() {
      return this.items.filter((item) => {
        return !this.search || item.description.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
